export default __webpack_public_path__ + "static/media/Consuption 1.22315030.svg";